// extracted by mini-css-extract-plugin
export default {"primeWrapper":"PrimeModal_primeWrapper__JicmO"};